import { post } from '../index'

export default {
  // 百度小程序配置信息
  getBaiduSettingUpdate (querys) {
    return post('/baidu/admin/AdminSetting/settingUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/baidu.js